import { defineStore } from 'pinia'
import { apiService } from '@/services/api'

export const useStaffStore = defineStore('staff', {
  state: () => ({
    staff: [],
    tableList: [],
    formData: null,
    template: [
      {
        label: '事業場情報',
        value: [
          {
            label: '事業場',
            value: [
              {
                label: '事業場名',
                value: '',
                type: 'select',
                options: [], // 事業場から取得する選択肢
              },
            ],
          },
        ],
      },
      {
        label: '従業員情報',
        value: [
          {
            label: '基本情報',
            value: [
              {
                label: '従業員番号',
                value: '',
                type: 'text',
              },
              {
                label: '氏名',
                value: ['', ''],
                type: 'name',
              },
              {
                label: '氏名カナ',
                value: ['', ''],
                type: 'name',
                pattern: '^[ァ-ヶー]+$',
                errorMessage: 'カタカナで入力してください',
              },
              {
                label: '性別',
                value: '',
                type: 'select',
                options: [
                  { label: '男', value: 'male' },
                  { label: '女', value: 'female' },
                ],
              },
              {
                label: '生年月日',
                value: '',
                type: 'date',
              },
              {
                label: '入社日',
                value: '',
                type: 'date',
              },
              {
                label: '勤続年数',
                value: '',
                type: 'text',
                disabled: true,
              },
            ],
          },
          {
            label: '退社情報',
            value: [
              {
                label: '退社日',
                value: '',
                type: 'date',
              },
              {
                label: '退社理由',
                value: '',
                type: 'text',
              },
            ],
          },
          {
            label: '保険関連',
            value: [
              {
                label: '労災保険区分',
                value: '',
                type: 'select',
                options: [], // 事業場から取得する選択肢
              },
            ],
          },
          {
            label: 'メモ',
            value: [
              {
                label: 'メモ',
                value: '',
                type: 'textarea',
              },
            ],
          },
        ],
      },
    ],
    formInit: {
      id: null,
      branchId: null,
      staffNumber: '',
      lastName: '',
      firstName: '',
      lastKana: '',
      firstKana: '',
      birthday: null,
      gender: '',
      joinDate: null,
      quitDate: null,
      quitReason: '',
      laborInsuranceType: '',
      memo: '',
    },
    // テンプレートパスとformDataのプロパティを関連付けるマッピング
    pathToFormDataMap: {
      // 事業場情報
      '事業場情報.事業場.事業場名': 'branchId',

      // 基本情報
      '従業員情報.基本情報.従業員番号': 'staffNumber',
      '従業員情報.基本情報.氏名': {
        type: 'array',
        keys: ['lastName', 'firstName'],
      },
      '従業員情報.基本情報.氏名カナ': {
        type: 'array',
        keys: ['lastKana', 'firstKana'],
      },
      '従業員情報.基本情報.性別': 'gender',
      '従業員情報.基本情報.生年月日': 'birthday',
      '従業員情報.基本情報.入社日': 'joinDate',

      // 退社情報
      '従業員情報.退社情報.退社日': 'quitDate',
      '従業員情報.退社情報.退社理由': 'quitReason',

      // 保険関連
      '従業員情報.保険関連.労災保険区分': 'laborInsuranceType',

      // メモ
      '従業員情報.メモ.メモ': 'memo',
    },
    currentCompanyId: null,
    initialStaffData: [],
    // 前回保存した状態を保持するプロパティを追加
    lastSavedData: null,
  }),
  actions: {
    // テンプレート操作ヘルパー関数 //////////////////////////////////////////

    // パスで指定された位置にある要素を検索する関数
    findByPath(template, path) {
      if (!template || !path || path.length === 0) return null

      let current = template

      // パスの最後の要素以外を処理
      for (let i = 0; i < path.length - 1; i++) {
        const label = path[i]
        if (!current) return null

        // 配列内を検索
        if (Array.isArray(current)) {
          const found = current.find(item => item.label === label)
          if (!found) return null
          current = found.value
        } else {
          return null // 配列でなければ探索不可
        }
      }

      // パスの最後の要素を検索
      const lastLabel = path[path.length - 1]
      if (Array.isArray(current)) {
        return current.find(item => item.label === lastLabel)
      }

      return null
    },

    // パスでフィールドの値を取得
    getFieldValueByPath(template, path) {
      // 修正: templateを引数として受け取るように変更
      if (!template) return null

      const field = this.findByPath(template, path)
      return field ? field.value : null
    },

    // 配列パスをドット区切り文字列に変換する
    pathToString(path) {
      return path.join('.')
    },

    // formDataからテンプレートに変換するメソッド（改善版）
    formDataToTemplate() {
      if (!this.formData) return this.getNewStaffTemplate()

      // ディープコピーしたテンプレートを取得
      const template = this.getNewStaffTemplate()

      // テンプレートを更新するためのヘルパー関数（改善版）
      const setTemplateValue = (template, path, value) => {
        if (!template || !path || path.length === 0) return
        if (value === undefined || value === null) return // 値がない場合は更新しない

        let current = template

        // パスの最後の要素以外を処理して位置を特定
        for (let i = 0; i < path.length - 1; i++) {
          const label = path[i]
          if (!current) return

          // 配列内を検索
          if (Array.isArray(current)) {
            const found = current.find(item => item.label === label)
            if (!found) {
              return // 要素が見つからない場合は早期リターン
            }
            current = found.value
          } else {
            return // 配列でなければ探索不可
          }
        }

        // パスの最後の要素を検索して値をセット
        const lastLabel = path[path.length - 1]
        if (Array.isArray(current)) {
          const field = current.find(item => item.label === lastLabel)
          if (field) {
            field.value = value
          }
        }
      }

      try {
        // 事業場情報
        setTemplateValue(template, ['事業場情報', '事業場', '事業場名'], this.formData.branchId)

        // 基本情報
        setTemplateValue(template, ['従業員情報', '基本情報', '従業員番号'], this.formData.staffNumber)
        setTemplateValue(template, ['従業員情報', '基本情報', '氏名'], [this.formData.lastName, this.formData.firstName])
        setTemplateValue(template, ['従業員情報', '基本情報', '氏名カナ'], [this.formData.lastKana, this.formData.firstKana])
        setTemplateValue(template, ['従業員情報', '基本情報', '性別'], this.formData.gender)
        setTemplateValue(template, ['従業員情報', '基本情報', '生年月日'], this.formData.birthday)
        setTemplateValue(template, ['従業員情報', '基本情報', '入社日'], this.formData.joinDate)
        const serviceYears = this.serviceYears ? this.serviceYears + '年' : ''
        setTemplateValue(template, ['従業員情報', '基本情報', '勤続年数'], serviceYears)

        // 退社情報
        setTemplateValue(template, ['従業員情報', '退社情報', '退社日'], this.formData.quitDate)
        setTemplateValue(template, ['従業員情報', '退社情報', '退社理由'], this.formData.quitReason)

        // 保険関連
        setTemplateValue(template, ['従業員情報', '保険関連', '労災保険区分'], this.formData.laborInsuranceType)

        // メモ
        setTemplateValue(template, ['従業員情報', 'メモ', 'メモ'], this.formData.memo)

        return template
      } catch (error) {
        // エラー発生時はデフォルトテンプレートを返す
        return this.getNewStaffTemplate()
      }
    },
    // テンプレートからformDataに変換するメソッド
    templateToFormData(template) {
      if (!template) return

      // formDataの初期化（既存値は保持）
      const newFormData = { ...this.formData }

      // 各パスからformDataへのマッピングを実行
      Object.entries(this.pathToFormDataMap).forEach(([pathStr, mapping]) => {
        const path = pathStr.split('.')
        const field = this.findByPath(template, path)

        if (field) {
          // 単純なマッピング
          if (typeof mapping === 'string') {
            newFormData[mapping] = field.value
          }
          // 配列値（姓名など）
          else if (mapping.type === 'array' && Array.isArray(field.value)) {
            mapping.keys.forEach((key, index) => {
              if (index < field.value.length) {
                newFormData[key] = field.value[index]
              }
            })
          }
        }
      })

      // formDataを更新
      this.formData = newFormData
    },

    // saveData処理を一元化
    async saveStaffData(newData) {
      // 現在のformDataをバックアップ
      const originalFormData = JSON.parse(JSON.stringify(this.formData))
      // 現在のテンプレートデータをバックアップ
      this.lastSavedData = JSON.parse(JSON.stringify(this.initialStaffData))

      // 変更前のformDataの値を保存
      const oldFormData = JSON.parse(JSON.stringify(this.formData))

      // テンプレートからformDataに変換
      this.templateToFormData(newData)

      try {
        // 変更されたセクションを1つだけ特定
        const changedSection = this.detectChangedSection(oldFormData, this.formData)

        // セクションの変更がない場合は何もしない
        if (!changedSection) {
          return null
        }

        // 変更されたセクションを更新
        const result = await this.updateStaffSection(changedSection)

        // 成功した場合は結果を返す
        if (result) {
          return result
        }
      } catch (error) {
        // エラーが発生した場合は元のformDataに戻す
        this.formData = originalFormData
        // 初期データも元に戻す
        this.initialStaffData = this.lastSavedData
        throw error
      }
    },

    // 変更があったセクションを検出するメソッド
    detectChangedSection(oldData, newData) {
      // セクションのマッピング
      const sections = {
        branchInfo: ['branchId'],
        basicInfo: ['staffNumber', 'lastName', 'firstName', 'lastKana', 'firstKana', 'birthday', 'gender', 'joinDate'],
        quitInfo: ['quitDate', 'quitReason'],
        insuranceInfo: ['laborInsuranceType'],
        memo: ['memo'],
      }

      // 値を比較する関数（nullと空文字列を同等と扱う）
      const isValueDifferent = (oldVal, newVal) => {
        // nullと空文字列を同等と扱う
        if ((oldVal === null || oldVal === '') && (newVal === null || newVal === '')) {
          return false
        }
        // 配列やオブジェクトの場合はJSON文字列化して比較
        return JSON.stringify(oldVal) !== JSON.stringify(newVal)
      }

      // 各セクションをチェック
      for (const [section, fields] of Object.entries(sections)) {
        // セクション内の各フィールドをチェック
        for (const field of fields) {
          const oldValue = oldData[field]
          const newValue = newData[field]

          // 修正した比較ロジックを使用
          if (isValueDifferent(oldValue, newValue)) {
            return section
          }
        }
      }

      return null
    },

    // テーブル表示用のリストを初期化
    initTableList() {
      this.tableList = [
        { label: 'No', key: 'rowNumber', data: (item, value) => value },
        { label: '事業所名', key: 'branchName', data: (item, value) => value },
        { label: '社員番号', key: 'staffNumber', data: (item, value) => value },
        { label: '氏名', key: 'name', data: (item, value) => value },
        { label: '年齢', key: 'age', data: (item, value) => (value ? `${value}歳` : '') },
        { label: '性別', key: 'gender', data: (item, value) => (value === 'male' ? '男性' : value === 'female' ? '女性' : '') },
        { label: '入社日', key: 'joinDate', data: (item, value) => value },
        { label: '退社日', key: 'quitDate', data: (item, value) => value || '' },
        {
          label: 'メモ',
          key: 'memo',
          data: (item, value) => {
            return value?.length > 20 ? value.substring(0, 20) + '...' : value
          },
        },
      ]
    },

    // currentCompanyIdを設定するメソッド
    setCurrentCompanyId(companyId) {
      this.currentCompanyId = companyId
    },

    // 新規従業員データ作成用テンプレートを取得
    getNewStaffTemplate() {
      // テンプレートのディープコピーを返す
      return JSON.parse(JSON.stringify(this.template))
    },

    // 代わりにgetStaffWithTemplateメソッドを追加
    async getStaffWithTemplate(id) {
      await this.getStaffDetail(id)
      return this.formDataToTemplate()
    },

    // 会社IDに紐づく従業員一覧を取得
    async getStaff(companyId) {
      try {
        const response = await apiService.get(`/api/companies/${companyId}/staff`)
        this.staff = response.staff
        // 会社IDを保存しておく
        this.currentCompanyId = companyId
        return true
      } catch (error) {
        return false
      }
    },

    // 従業員の詳細情報を取得
    async getStaffDetail(id) {
      try {
        const response = await apiService.get(`/api/staff/${id}`)
        this.formData = response.staff

        // 取得したデータを現在の「保存済み」状態として記録
        this.lastSavedData = null // 一度クリア

        return true
      } catch (error) {
        return false
      }
    },

    // 新規従業員作成メソッド - formDataを直接使用
    async createStaff() {
      try {
        const response = await apiService.post('/api/staff', this.formData)
        await this.getStaffDetail(response.staffId)
        return response.message
      } catch (error) {
        return null
      }
    },

    // 共通のAPIリクエストデータ構築メソッド
    buildApiRequestData(section) {
      if (!this.formData) return null

      const baseData = { id: this.formData.id }

      switch (section) {
        case 'branchInfo':
          return {
            ...baseData,
            branchId: this.formData.branchId,
          }
        case 'basicInfo':
          return {
            ...baseData,
            staffNumber: this.formData.staffNumber,
            lastName: this.formData.lastName,
            firstName: this.formData.firstName,
            lastKana: this.formData.lastKana,
            firstKana: this.formData.firstKana,
            joinDate: this.formData.joinDate,
            birthday: this.formData.birthday,
            gender: this.formData.gender,
          }
        case 'quitInfo':
          return {
            ...baseData,
            quit_date: this.formData.quitDate,
            quit_reason: this.formData.quitReason,
          }
        case 'insuranceInfo':
          return {
            ...baseData,
            labor_insurance_type: this.formData.laborInsuranceType,
          }
        case 'memo':
          return {
            ...baseData,
            memo: this.formData.memo,
          }
        default:
          return null
      }
    },

    // 簡略化されたAPI更新メソッド
    async updateStaffSection(section) {
      const endpoints = {
        branchInfo: '/api/staff/branch-info',
        basicInfo: '/api/staff/basic-info',
        quitInfo: '/api/staff/quit-info',
        insuranceInfo: '/api/staff/insurance-info',
        memo: '/api/staff/memo',
      }

      const data = this.buildApiRequestData(section)
      if (!data) return null

      try {
        const response = await apiService.post(endpoints[section], data)

        // 更新が成功したら、現在の状態を「保存済み」状態として保存
        this.lastSavedData = JSON.parse(JSON.stringify(this.initialStaffData))

        return response.message
      } catch (error) {
        throw error
      }
    },

    // 従業員を削除
    async deleteStaff() {
      try {
        const response = await apiService.delete(`/api/staff/${this.formData.id}`)
        await this.getStaff(this.currentCompanyId)
        return response.message
      } catch (error) {
        return null
      }
    },

    // IDで従業員を検索
    getStaffById(id) {
      return this.staff.find(staff => staff.id === Number(id))
    },

    // 詳細データをクリア（事業場IDを指定可能）
    clearDetailData(branchId) {
      this.formData = JSON.parse(JSON.stringify(this.formInit))

      // 事業場IDを設定する場合
      if (branchId) {
        this.formData.branchId = Number(branchId)
      }

      // テンプレートを初期化
      this.initialStaffData = this.formDataToTemplate()
      // 保存済みデータも初期化
      this.lastSavedData = JSON.parse(JSON.stringify(this.initialStaffData))
    },

    // 従業員情報で詳細データを初期化
    async initDetailData(staffId) {
      const result = await this.getStaffDetail(Number(staffId))
      if (!result) {
        return false
      }
      this.initialStaffData = this.formDataToTemplate()
      // 取得したデータを保存済みデータとして保存
      this.lastSavedData = JSON.parse(JSON.stringify(this.initialStaffData))
      return true
    },

    // 従業員情報を初期化
    clearInitialStaffData() {
      this.formData = JSON.parse(JSON.stringify(this.formInit))
      this.initialStaffData = this.formDataToTemplate()
    },
  },
  getters: {
    fullName() {
      if (!this.formData) return ''
      return `${this.formData.lastName} ${this.formData.firstName}`
    },
    fullNameKana() {
      if (!this.formData) return ''
      return `${this.formData.lastKana} ${this.formData.firstKana}`
    },
    employmentStatus() {
      if (!this.formData) return ''
      return this.formData.quitDate ? '退職' : '在職中'
    },
    serviceYears() {
      if (!this.formData || !this.formData.joinDate) return null

      const joinDate = new Date(this.formData.joinDate)
      const endDate = this.formData.quitDate ? new Date(this.formData.quitDate) : new Date()

      const diffYears = endDate.getFullYear() - joinDate.getFullYear()
      const diffMonths = endDate.getMonth() - joinDate.getMonth()

      if (diffMonths < 0 || (diffMonths === 0 && endDate.getDate() < joinDate.getDate())) {
        return diffYears - 1
      }

      return diffYears
    },
    // 新規追加: 新規作成モードか判定するゲッター
    isNewStaff: state => staffId => {
      return staffId === 'new'
    },
  },
})
